import type { VehicleFinance } from '@core/Entities/Vehicle/VehicleFinance.entity';

import styles from './RepresentativeExampleList.module.css';

type Props = {
  finance: VehicleFinance;
};

export const RepresentativeExampleList = ({ finance }: Props) => {
  const fullDisclaimer = finance.legalText?.fullDisclaimer;
  if (!fullDisclaimer) return null;

  const entries = fullDisclaimer
    .replace('Representative example: ', '')
    .split(', ')
    .map(entry => {
      const [label, value] = entry.split(': ');
      return { label, value };
    });

  return (
    <ul className={styles.entryList}>
      {entries.map(({ label, value }) => (
        <li key={label}>
          <span className={styles.entryLabel}>{label}</span>
          <span className={styles.entryValue}>{value}</span>
        </li>
      ))}
    </ul>
  );
};
